import { Button } from "primereact/button";
import { Image } from "primereact/image";
import ImageCanvas from "./ImageCanvas";
import MarkingControlButton from "./MarkingControlButton";
import MarkingProblemTable from "../foto/MarkingProblemTable";
import { getMarkingReferenceImage } from "../../utils/getMarkingReferenceImage";
import { splitProblemsByAge } from "../../utils/checklistProblem";

const MarkingList = ({
  field,
  title,
  labelGrup,
  headerData,
  pengecekanData,
  pengecekanDetilData,
  loading,
  disabled,
  onClickCamera,
  onClickAddMarking,
  onChangeKordinat,
  onClickRemove,
  onClickSave,
  onClickReload,
  listProblemData,
  folderName,
}) => {
  const filteredDetilData = pengecekanDetilData
    ? pengecekanDetilData
        .filter((el) => el.label_grup === labelGrup)
        .sort((a, b) => a.urutan - b.urutan)
    : [];

  const handleOnClickSave = () => {
    if (onClickSave) {
      onClickSave(labelGrup, filteredDetilData);
    }
  };

  // the open problems of this group: younger than a week are new, the rest are old
  const { newProblems, oldProblems } = splitProblemsByAge(listProblemData);

  return (
    <div className="col-start-start w-full gap-3">
      <div className="row-between-center w-full">
        <span className="font-bold text-sm text-stone-700">{title}</span>
        <Button
          loading={loading}
          className="!p-0 max-h-[1.3rem] max-w-[1.3rem]"
          icon="pi pi-refresh"
          text
          rounded
          onClick={onClickReload}
        />
      </div>

      {/* block 1: the real photo - view only, this is what the Foto button writes to */}
      <div className="col-start-start gap-1 w-full">
        <div className="row-between-center w-full">
          <span className="text-xs font-semibold text-slate-400">Foto Asli</span>
          <Button
            disabled={disabled}
            className="max-h-[2rem]"
            icon="pi pi-camera"
            text
            label="Foto"
            onClick={() => onClickCamera(field)}
          />
        </div>
        {pengecekanData && pengecekanData[field] ? (
          <Image
            className="bg-white shadow-md w-full"
            src={pengecekanData[field]}
            alt={field}
            width="100%"
            preview
          />
        ) : (
          <div className="row-center-center bg-slate-100 text-slate-400 text-sm italic w-full h-[6rem] rounded">
            Belum ada foto
          </div>
        )}
      </div>

      {/* block 2: the reference model - the permanent marking surface, Beri Tanda lives here. The uploaded
      jenis_mobil photo is used when one exists, otherwise the generic outline illustration */}
      <div className="col-start-start gap-1 w-full">
        <span className="text-xs font-semibold text-slate-400">Model Referensi</span>
        <ImageCanvas
          onChangeKordinat={onChangeKordinat}
          imageUrl={getMarkingReferenceImage({ headerData, field })}
          markings={filteredDetilData}
          disabled={disabled}
        />
        <div className="row-between-center w-full">
          <Button
            disabled={disabled}
            loading={loading}
            className="max-h-[2.5rem]"
            icon="pi pi-plus-circle"
            outlined
            label="Beri Tanda"
            onClick={() => onClickAddMarking(field)}
          />
          <Button
            loading={loading}
            disabled={disabled}
            className="max-h-[2.5rem]"
            icon="pi pi-save"
            label="Save"
            severity="success"
            onClick={handleOnClickSave}
          />
        </div>
      </div>

      {filteredDetilData.length > 0 && (
        <div className="col-start-start w-full gap-1">
          <span className="text-xs font-semibold text-slate-400">
            Tanda Baru (audit ini)
          </span>
          <div className="col-start-start w-full gap-[0.4rem]">
            {filteredDetilData.map((el) => (
              <MarkingControlButton
                key={el.id || el._localId}
                data={el}
                disabled={disabled}
                onClickRemove={onClickRemove}
              />
            ))}
          </div>
        </div>
      )}

      {/* block 3: checklist-style tables of the open problems of this group: new (younger than a week) and old */}
      {!disabled && newProblems.length > 0 && (
        <div className="col-start-start w-full gap-1">
          <span className="text-xs font-semibold text-slate-400">
            Problem Baru
          </span>
          <MarkingProblemTable
            listProblemData={newProblems}
            disabled={disabled}
            folderName={folderName}
          />
        </div>
      )}
      {!disabled && oldProblems.length > 0 && (
        <div className="col-start-start w-full gap-1">
          <span className="text-xs font-semibold text-slate-400">
            Problem Lama
          </span>
          <MarkingProblemTable
            listProblemData={oldProblems}
            disabled={disabled}
            folderName={folderName}
          />
        </div>
      )}
    </div>
  );
};

export default MarkingList;
